// extracted by mini-css-extract-plugin
export default {"logo":"AboutPage_logo__AisNN","container":"AboutPage_container__8CJIM","aboutUs":"AboutPage_aboutUs__eerah","hallOfFame":"AboutPage_hallOfFame__cHfDo","tags":"AboutPage_tags__RkkjI"};